import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "stage-container"
};
const _hoisted_3 = {
  class: "options-container"
};
const _hoisted_4 = {
  class: "form-tag"
};
const _hoisted_5 = {
  class: "recruitment-bar"
};
const _hoisted_6 = {
  class: "pagination-container"
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  class: "stage-container"
};
const _hoisted_9 = {
  class: "options-container"
};
const _hoisted_10 = {
  class: "form-tag"
};
const _hoisted_11 = {
  key: 0,
  class: "recruitment-bar"
};
const _hoisted_12 = {
  key: 1,
  class: "application-records-container"
};
const _hoisted_13 = {
  key: 0,
  class: "empty-data-tips"
};
const _hoisted_14 = {
  class: "options-cell"
};
const _hoisted_15 = {
  key: 3,
  class: "pagination-container"
};
const _hoisted_16 = {
  class: "invite-link-container"
};
const _hoisted_17 = {
  class: "invite-link"
};
const _hoisted_18 = {
  class: "dialog-footer"
};
import { computed, onMounted, provide, ref } from 'vue';
import { ElRow, ElButton, ElInput, ElMessage, ElSwitch, ElInputNumber, ElSelect, ElCol } from 'element-plus';
import { isAdminType, inApostleType, isUserType } from '@/tools/utils';
import { request } from '@/manager/net_manager';
import store from '@/store';
import _ from 'lodash';
import ApplicationRecordCard from '@/components/Stage/ApplicationRecordCard.vue';
import RecruitmentStageCard from "@/components/Stage/RecruitmentStageCard.vue";
import RoleSelector from "@/components/Role/RoleSelector.vue";
import MaskerLayer from "@/components/Basic/MaskerLayer.vue";
import { pageStyle } from "@/theme/sliderStyle";
import router from "@/router"; // constants

export default {
  __name: 'LoungePage',

  setup(__props) {
    const positionOptions = [{
      id: 0,
      desc: '演职员'
    }, {
      id: 1,
      desc: '观众席'
    }]; // refs

    const pagerCount = ref(5);
    const size = ref(8);
    const total = ref(0);
    const page = ref(0); // 选中者特有

    const recruitment = ref([]);
    const applications = ref([]);
    const recordsMode = ref(false);
    const invitationLetter = ref('');
    const applyStage = ref(null);
    const applyType = ref(null);
    const applyTimes = ref(null); // 链接者特有

    const reminderFlag = ref(false);
    const reminderTitle = ref('');
    const reminderContent = ref('');
    const reminderEvent = ref(null);
    const invitePosition = ref(0);
    const inviteTimes = ref(0);
    const inviteLink = ref(null); // computed

    const worldOutlook = computed(() => {
      if (isUserType(userType.value)) return store.state.world_outlook ?? null;
      if (isAdminType(userType.value)) return store.state.world_outlook ?? null;
      if (inApostleType(userType.value)) return store.state.user.apostle_wo ?? null;
      return null;
    });
    const userType = computed(() => {
      return store.state.user ? parseInt(store.state.user.user_type) : 4;
    });
    const dataArray = computed(() => {
      const buffer = [...recruitment.value];
      if (recruitment.value.length === 0) buffer.push(null);

      while (buffer.length === 0 || buffer.length % 8 !== 0) {
        buffer.push(null);
      }

      return buffer;
    });
    const roleArray = computed(() => store.state.role_array ?? []); // functions

    const onModeChange = _.debounce(() => {
      page.value = 0;

      if (recordsMode.value) {
        getApplicationsData();
      } else {
        getStageData();
      }
    }, 300);

    const getApplicationsData = () => {
      if (!worldOutlook.value) return;
      let parameters = {};
      parameters['world_outlook_id'] = worldOutlook.value.id;
      parameters['page'] = page.value;
      parameters['size'] = size.value;
      request('stage/applications/list/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          applications.value = response.data.applications;
          total.value = response.data.numbers;
        }
      });
    };

    const getStageData = () => {
      if (!worldOutlook.value) return;
      let parameters = {};
      parameters['world_outlook_id'] = worldOutlook.value.id;
      parameters['page'] = page.value;
      parameters['size'] = size.value;
      request('stage/list/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          recruitment.value = response.data.stages;
          total.value = response.data.numbers;
        }
      });
    };

    const handlePageChange = index => {
      page.value = index - 1;

      if (recordsMode.value) {
        getApplicationsData();
      } else {
        getStageData();
      }
    };

    const stageUpdate = stage_id => {
      router.push({
        name: 'stageGenerator',
        params: {
          stage_id: stage_id
        }
      });
    };

    const stageShare = async stage_item => {
      reminderFlag.value = true;
      reminderTitle.value = `舞台邀请`;
      reminderContent.value = `收到邀请函的角色可以直接加入舞台的对应席位，无需二次同意（每张邀请函的有效期是24h）`;
      inviteLink.value = null;

      reminderEvent.value = confirm => {
        const parameters = {
          'stage_id': stage_item.stage_id,
          'position': invitePosition.value,
          'times': inviteTimes.value
        };
        invitePosition.value = 0;
        inviteTimes.value = 0;

        if (confirm) {
          if (inviteLink.value) {
            inviteLink.value = null;
            cancelDialogParas();
            return;
          }

          request('stage/share/create/', parameters, 'POST').then(async response => {
            // console.log(JSON.stringify(response))
            if (response.code === 0) {
              try {
                await navigator.clipboard.writeText(response.data ?? '');
                ElMessage.success({
                  message: '已复制邀请函至剪贴板',
                  duration: 1500
                });
                cancelDialogParas();
              } catch (err) {
                inviteLink.value = response.data ?? '';
                ElMessage.warning({
                  message: '部分浏览器无法应用自动复制',
                  duration: 1500
                });
              }
            } else {
              ElMessage.error({
                message: response.msg,
                duration: 1500
              });
              cancelDialogParas();
            }
          });
        } else {
          inviteLink.value = null;
          cancelDialogParas();
        }
      };
    };

    const cancelDialogParas = () => {
      reminderEvent.value = null;
      reminderFlag.value = false;
      reminderTitle.value = '';
      reminderContent.value = '';
    };

    const submitInvitationLetter = () => {
      request('stage/share/get/', {
        'link': invitationLetter.value
      }, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          applyStage.value = response.data.stage;
          applyType.value = response.data.position;
          applyTimes.value = response.data.times;
        } else {
          invitationLetter.value = '';
          ElMessage.error(response.msg);
        }
      });
    };

    const cancelApplication = applicationId => {
      request('stage/applications/cancel/', {
        'application_id': applicationId
      }, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          getApplicationsData();
        } else {
          ElMessage.error(response.msg);
        }
      });
    };

    const stageApply = (stageData, ticketType) => {
      applyStage.value = stageData;
      applyType.value = ticketType;
      applyTimes.value = null;
    };

    const submitTicketApply = (stageId, ticketType, roleId) => {
      applyStage.value = null;
      applyType.value = null;
      applyTimes.value = null;

      if (invitationLetter.value === null || invitationLetter.value.length === 0) {
        let parameters = {
          'role_id': roleId,
          'stage_id': stageId,
          'position': ticketType
        };
        request('stage/apply/', parameters, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            ElMessage.success({
              message: '成功提交申请',
              duration: 1500
            });
            getStageData();
          } else {
            ElMessage.error({
              message: response.msg,
              duration: 1500
            });
          }
        });
      } else {
        let parameters = {
          'role_id': roleId,
          'link': invitationLetter.value
        };
        request('stage/share/join/', parameters, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            ElMessage.success({
              message: '成功加入舞台',
              duration: 1500
            });
            invitationLetter.value = '';
            getStageData();
          } else {
            ElMessage.error({
              message: response.msg,
              duration: 1500
            });
          }
        });
      }
    }; // lifecycle


    onMounted(() => {
      if (roleArray.value.length === 0) {
        store.dispatch('get_roles');
      }

      getStageData();
    }); // post-declaration

    provide('stageService', {
      find_stage: submitInvitationLetter,
      stage_update: stageUpdate,
      stage_share: stageShare,
      get_stages: getStageData,
      stage_apply: stageApply
    });
    return (_ctx, _cache) => {
      const _component_el_pagination = _resolveComponent("el-pagination");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        id: "page-container",
        style: _normalizeStyle(_unref(pageStyle))
      }, [_unref(inApostleType)(userType.value) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("text", _hoisted_4, _toDisplayString(worldOutlook.value ? `${worldOutlook.value.name} / ` : '') + " 演出后台 ", 1)]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataArray.value, (item, index) => {
        return _openBlock(), _createBlock(RecruitmentStageCard, {
          key: index,
          class: "grid-card",
          data: item
        }, null, 8, ["data"]);
      }), 128))]), _withDirectives(_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_pagination, {
        "page-size": size.value,
        "pager-count": pagerCount.value,
        layout: "prev, pager, next",
        total: total.value,
        background: true,
        onChange: handlePageChange
      }, null, 8, ["page-size", "pager-count", "total"])], 512), [[_vShow, total.value > size.value]])])])) : _unref(isUserType)(userType.value) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("text", _hoisted_10, _toDisplayString(worldOutlook.value ? `${worldOutlook.value.name} / ` : '') + " " + _toDisplayString(!recordsMode.value ? '演出厅' : '申请记录表'), 1), _createVNode(_unref(ElRow), {
        style: {
          "justify-content": "flex-end",
          "flex": "1"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElSwitch), {
          modelValue: recordsMode.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => recordsMode.value = $event),
          "inline-prompt": "",
          "active-text": recordsMode.value ? '申请记录' : '',
          "inactive-text": recordsMode.value ? '' : '演出大厅',
          onChange: _unref(onModeChange)
        }, null, 8, ["modelValue", "active-text", "inactive-text", "onChange"])]),
        _: 1
      })]), !recordsMode.value ? (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataArray.value, (item, index) => {
        return _openBlock(), _createBlock(RecruitmentStageCard, {
          key: index,
          data: item,
          class: "grid-card"
        }, null, 8, ["data"]);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [applications.value.length === 0 ? (_openBlock(), _createElementBlock("text", _hoisted_13, " 尚未提交任何舞台申请 ")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(applications.value, (item, index) => {
        return _openBlock(), _createBlock(ApplicationRecordCard, {
          key: index,
          data: item,
          onUpdate: cancelApplication
        }, null, 8, ["data"]);
      }), 128))])), !recordsMode.value ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 2,
        style: {
          "justify-content": "flex-end"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createVNode(_unref(ElInput), {
          modelValue: invitationLetter.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => invitationLetter.value = $event),
          maxlength: "64",
          type: "text",
          placeholder: "邀请函"
        }, null, 8, ["modelValue"]), _createVNode(_unref(ElButton), {
          class: "invitation",
          onClick: submitInvitationLetter
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode(" 确认提交 ", -1)]))]),
          _: 1
        })])]),
        _: 1
      })) : _createCommentVNode("", true), total.value > size.value ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_el_pagination, {
        "page-size": size.value,
        "pager-count": pagerCount.value,
        layout: "prev, pager, next",
        total: total.value,
        background: true,
        onChange: handlePageChange
      }, null, 8, ["page-size", "pager-count", "total"])])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)], 4), _createVNode(_component_el_dialog, {
        modelValue: reminderFlag.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => reminderFlag.value = $event),
        title: reminderTitle.value,
        width: "800"
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createVNode(_unref(ElButton), {
          onClick: _cache[4] || (_cache[4] = $event => reminderEvent.value(true))
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("确认", -1)]))]),
          _: 1
        }), _createVNode(_unref(ElButton), {
          class: "cancel",
          onClick: _cache[5] || (_cache[5] = $event => reminderEvent.value(false))
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("取消", -1)]))]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_unref(ElCol), {
          style: {
            "gap": "16px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(reminderContent.value), 1)]),
            _: 1
          }), _createVNode(_unref(ElRow), {
            style: {
              "margin-top": "36px"
            }
          }, {
            default: _withCtx(() => [!inviteLink.value ? (_openBlock(), _createBlock(_unref(ElCol), {
              key: 0
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "邀请席位",
                "label-position": "left"
              }, {
                default: _withCtx(() => [_createVNode(_unref(ElSelect), {
                  modelValue: invitePosition.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => invitePosition.value = $event),
                  "show-arrow": false,
                  placeholder: "邀请席位",
                  "popper-class": "commonPopper"
                }, {
                  default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(positionOptions, item => {
                    return _createVNode(_component_el_option, {
                      key: item.id,
                      label: item.desc,
                      value: item.id
                    }, null, 8, ["label", "value"]);
                  }), 64))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "次数限制",
                "label-position": "left"
              }, {
                default: _withCtx(() => [_createVNode(_unref(ElInputNumber), {
                  modelValue: inviteTimes.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => inviteTimes.value = $event),
                  min: 0,
                  max: 10,
                  placeholder: "有效次数"
                }, null, 8, ["modelValue"]), _cache[9] || (_cache[9] = _createElementVNode("text", {
                  class: "tips"
                }, "设置为0时不限制邀请函的有效次数", -1))]),
                _: 1
              })]),
              _: 1
            })) : (_openBlock(), _createBlock(_unref(ElRow), {
              key: 1
            }, {
              default: _withCtx(() => [_createElementVNode("text", _hoisted_16, [_cache[10] || (_cache[10] = _createTextVNode(" 邀请函已生成： ", -1)), _createElementVNode("span", _hoisted_17, _toDisplayString(inviteLink.value), 1)])]),
              _: 1
            }))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "title"]), applyStage.value !== null && applyType.value !== null ? (_openBlock(), _createBlock(MaskerLayer, {
        key: 0,
        onClose: _cache[7] || (_cache[7] = $event => {
          applyStage.value = null;
          applyType.value = null;
        })
      }, {
        default: _withCtx(() => [_createVNode(RoleSelector, {
          data: applyStage.value,
          "ticket-type": applyType.value,
          "invite-link": invitationLetter.value,
          times: applyTimes.value,
          onSelectedRole: submitTicketApply
        }, null, 8, ["data", "ticket-type", "invite-link", "times"])]),
        _: 1
      })) : _createCommentVNode("", true)], 64);
    };
  }

};